import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import moment from 'moment';
import { isBrowserSafari } from '../../../utils';
import ScrollArea from 'react-scrollbar';

import './hourPicker.css';

class HourPicker extends Component {
    constructor() {
        super();
        this.state = {};
    }

    convertToHours(number) {

        return moment().startOf('day')
            .seconds(number || 0)
            .format('HH:mm');
    }

    onSelectHour(eventKey) {
        this.props.updateTime(eventKey);
        this.toggleDropdown();
    }

    toggleDropdown() {
        this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen });
        this.child.onOpen(this.props.time || 75600);
    }

    render(){

        return (
            <div className={`hour-picker-wrapper ${isBrowserSafari() ? 'safari' : ''}`}>
                <DropdownButton
                    title={this.convertToHours(this.props.time)}
                    id="dropdown"
                    noCaret={true}
                    onToggle={() => this.toggleDropdown()}
                    data-toggle="dropdown"
                    open={this.state.dropdownIsOpen}
                >
                    <ScrollArea
                        speed={0.8}
                        className="area"
                        horizontal={false}
                    >
                        <Content onSelect={time => this.onSelectHour(time)} onRef={ref => { this.child = ref }} time={this.props.time} />
                    </ScrollArea>
                </DropdownButton>
            </div>
        )
    }
}

HourPicker.propTypes = {
    time: PropTypes.number,
    userShouldEnter: PropTypes.array,
    updateTime: PropTypes.func,
};

export default HourPicker;

class Content extends Component {
    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    convertToHours(number) {
        return moment().startOf('day')
            .seconds(number)
            .format('HH:mm');
    }

    onSelectTime(time) {
        this.props.onSelect(time)
    }

    onOpen(time) {

        const scrollRatio = time / ((24 * 3600) / 900);
        setTimeout(() => {
            this.context.scrollArea.scrollYTo(scrollRatio);
        }, 100)
    }

    render() {
        const hourItems = [];

        // TODO: entry every 30 mins is hard coded
        for (let i = 0; i < 24 * 3600; i += 1800) {
            hourItems.push(
                <MenuItem
                    key={i}
                    eventKey={i}
                    className={i === this.props.time ? 'selected' : null}
                    onSelect={eventKey => this.onSelectTime(eventKey)}
                >
                    {this.convertToHours(i)}
                </MenuItem>
            );
        }

        return (
            <div className="hours">
                {hourItems}
            </div>
        )
    }
}

Content.propTypes = {
    onSelect: PropTypes.func,
    onRef: PropTypes.func,
    time: PropTypes.number
};

Content.contextTypes = {
    scrollArea: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/Components/Elements/Pickers/HourPicker.js